module.exports = __webpack_public_path__ + "img/sunglasses.af14796b.png";